import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const useRiskInsightsMessages = (isLoading, interval = 3000) => {
  const { t } = useTranslation();
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const messages = [
    t("risk_insights.loading_messages.message1"),
    t("risk_insights.loading_messages.message2"),
    t("risk_insights.loading_messages.message3"),
    t("risk_insights.loading_messages.message4"),
    t("risk_insights.loading_messages.message5"),
    t("risk_insights.loading_messages.message6"),
  ];

  useEffect(() => {
    if (!isLoading) {
      setCurrentMessageIndex(0);
      return;
    }

    const timer = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % messages.length);
    }, interval);

    return () => clearInterval(timer);
  }, [isLoading, interval, messages.length]);

  return messages[currentMessageIndex] || "";
};

export default useRiskInsightsMessages;
